module.exports = __webpack_public_path__ + "static/media/01A.ffd11451.png";